import React, { useEffect } from "react";
import styles from "../onboard.module.css";
import { Col, Row } from "react-bootstrap";
import SignInInput from "../../../common/SigninInput/signinInput";
import Dropdown from "../../Dropdown/dropdown";
import CommonButton from "../../CommonButton/CommonButton";
import { useMyContext } from "../../../myContext";

function BeneficiaryBankForm({
  accountHolderName,
  setAccountHolderName,
  valid,
  bankName,
  setBankName,
  accountNumber,
  setAccountNumber,
  handleChangeOption,
  accountTypeError,
  bankAddress,
  setBankAddress,
  branchName,
  setBranchName,
  swiftCode,
  setSwiftCode,
  tranferCode,
  ibanBsbRouting1,
  setIbanBsbRouting1,
  ibanBsbRouting2,
  setIbanBsbRouting2,
  setCurrency,
  nextSectionError,
  checkIfValid,
  loading,
  confirmAccNumber,
  setConfirmAccNumber,
  confirmAccNoErrror,
  setConfirmAccNoError,
  currencyError,
}) {
  const { countryObject } = useMyContext();

  useEffect(() => {
    if (confirmAccNumber !== "" && accountNumber !== confirmAccNumber) {
      setConfirmAccNoError("Account number does not match");
    } else {
      setConfirmAccNoError("");
    }
  }, [accountNumber]);

  const BeneficiaryAccountType = [
    {
      label: "Checking",
      value: "checking",
    },
    {
      label: "Saving",
      value: "savings",
    },
  ];

  const handleBlur = (e) => {
    if (e.target.name === "ConfirmAccountNumber") {
      if (confirmAccNumber !== "" && accountNumber !== confirmAccNumber) {
        setConfirmAccNoError("Account number does not match");
      } else {
        setConfirmAccNoError("");
      }
    }
  };

  let currencyOption = [];

  countryObject?.currencyList.forEach((key) => {
    currencyOption.push({
      label: key,
      value: key,
    });
  });

  const handleChangeOptionforCurrency = (value) => {
    setCurrency(value);
    sessionStorage.setItem("currencyCode", value);
  };

  return (
    <div>
      {countryObject?.currencyList.length > 1 && (
        <Row>
          <Col md={4}>
            <Dropdown
              options={currencyOption}
              heading="Currency"
              label={"Select Currency"}
              onChange={handleChangeOptionforCurrency}
              // labelstyle={country ? true : false}
              // Dropdownlistchange={Dropdownlistchange}
            />
          </Col>
          {currencyError !== "" ? (
            <div className={styles.errorState}>{currencyError}</div>
          ) : (
            ""
          )}
        </Row>
      )}
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="AccountHolderName"
            label="Account Holder Name"
            placeholder="Enter Full Name"
            type="text"
            value={accountHolderName}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setAccountHolderName(event.target.value);
            }}
            isInvalid={valid.accountHolderName}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="BankName"
            label="Bank Name"
            placeholder="Enter Bank Name"
            type="text"
            value={bankName}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setBankName(event.target.value);
            }}
            isInvalid={valid.bankName}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="AccountNumber"
            label="Account Number"
            placeholder="Enter Account Number"
            type="password"
            value={accountNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setAccountNumber(event.target.value);
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            isInvalid={valid.accountNumber}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="ConfirmAccountNumber"
            label="Confirm Account Number"
            placeholder="Enter Confirm Account Number"
            type="text"
            value={confirmAccNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setConfirmAccNumber(event.target.value);
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            onBlur={(event) => {
              handleBlur(event);
            }}
            isInvalid={valid.confirmAccNumber}
            errorMessage={confirmAccNoErrror}
          />
        </Col>
        <Col md={4}>
          <Dropdown
            options={BeneficiaryAccountType}
            label="Select Account Type"
            heading="Account Type"
            onChange={handleChangeOption}
          />
          {accountTypeError !== "" ? (
            <div className={styles.errorState}>{accountTypeError}</div>
          ) : (
            ""
          )}
        </Col>
        <Col md={4}>
          <SignInInput
            name="bankAddress"
            label="Bank Address"
            placeholder="Enter bank address"
            type="text"
            value={bankAddress}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setBankAddress(event.target.value);
            }}
            isInvalid={valid.bankAddress}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="branchName"
            label="Branch Name"
            placeholder="Enter Branch Name"
            type="text"
            value={branchName}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setBranchName(event.target.value);
            }}
            isInvalid={valid.branchName}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="swiftCode"
            label="Swift Code"
            placeholder="Enter SwiftCode"
            type="text"
            value={swiftCode}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setSwiftCode(event.target.value);
            }}
            isInvalid={valid.swiftCode}
          />
        </Col>
        {tranferCode && tranferCode.length > 0 && tranferCode[0] !== "" ? (
          <Col md={4}>
            <SignInInput
              name="ibanBsbRouting1"
              label={
                tranferCode[0] === "sortCode"
                  ? "Sort Code"
                  : tranferCode[0] === "Transit Number"
                    ? "Transit Number"
                    : tranferCode[0] === "bsbCode"
                      ? "BSB"
                      : tranferCode[0] === "ibanNo"
                        ? "IBAN"
                        : tranferCode[0] === "routingNo"
                          ? "Routing Number"
                          : ""
              }
              placeholder={
                tranferCode[0] === "sortCode"
                  ? "Enter Sort Code"
                  : tranferCode[0] === "Transit Number"
                    ? "Enter Transit Number"
                    : tranferCode[0] === "bsbCode"
                      ? "Enter BSB"
                      : tranferCode[0] === "ibanNo"
                        ? "Enter IBAN"
                        : tranferCode[0] === "routingNo"
                          ? "Enter Routing Number"
                          : null
              }
              type="text"
              value={ibanBsbRouting1}
              containerClasses={styles.passwordInvalid}
              isInvalid={valid.ibanBsbRouting1}
              onChange={(event) => {
                setIbanBsbRouting1(event.target.value);
              }}
            />
          </Col>
        ) : (
          ""
        )}
        {tranferCode && tranferCode.length === 2 ? (
          <Col
            md={4}
            className={tranferCode && tranferCode.length === 1 ? "pt-2" : ""}
          >
            <SignInInput
              name="ibanBsbRouting2"
              label={
                tranferCode[1] === "sortCode"
                  ? "Sort Code"
                  : tranferCode[1] === "Transit Number"
                    ? "Transit Number"
                    : tranferCode[1] === "bsbCode"
                      ? "BSB"
                      : tranferCode[1] === "ibanNo"
                        ? "IBAN"
                        : tranferCode[1] === "routingNo"
                          ? "Routing Number"
                          : ""
              }
              placeholder={
                tranferCode[1] === "sortCode"
                  ? "Enter Sort Code"
                  : tranferCode[1] === "Transit Number"
                    ? "Enter Transit Number"
                    : tranferCode[1] === "bsbCode"
                      ? "Enter BSB"
                      : tranferCode[1] === "ibanNo"
                        ? "Enter IBAN"
                        : tranferCode[1] === "routingNo"
                          ? "Enter Routing Number"
                          : null
              }
              type="text"
              value={ibanBsbRouting2}
              containerClasses={styles.passwordInvalid}
              isInvalid={valid.ibanBsbRouting2}
              onChange={(event) => {
                setIbanBsbRouting2(event.target.value);
              }}
            />
          </Col>
        ) : (
          ""
        )}
      </Row>
      <Row className="pt-3 mt-3">
        <div className={styles.errorState}>{nextSectionError}</div>
        <CommonButton
          title="Next"
          onClick={checkIfValid}
          loading={loading}
          disabled={loading}
          width={"150px"}
          // padding: 10px 50px;
        />
        {/* <Button
            className={styles.button}
            onClick={checkIfValid}
            disabled={loading}
            style={{background: themeColor}}
          >
            {loading && (
              <Spinner animation="border" className={styles.spinnerColor} style={{borderColor: themeColor, borderRightColor: "white"}}/>
            )}
            Next
          </Button> */}
      </Row>
    </div>
  );
}

export default BeneficiaryBankForm;
